export const RiskMeter = ({ label, value = 0, kind = "quality", testid }) => {
    const pct = Math.max(0, Math.min(10, value)) * 10;
    const isRisk = kind === "risk";
    const color = isRisk
        ? value >= 7
            ? "bg-[#ff2a2a]"
            : value >= 4
            ? "bg-[#ffb800]"
            : "bg-[#f5f5f0]"
        : value >= 7
        ? "bg-[#f5f5f0]"
        : value >= 4
        ? "bg-[#8a8a8a]"
        : "bg-[#262626]";

    return (
        <div data-testid={testid || `risk-meter-${label}`} className="space-y-1">
            <div className="flex items-center justify-between">
                <span className="d8-label">{label}</span>
                <span
                    className={`font-mono-d8 text-xs tabular-nums ${
                        isRisk && value >= 7 ? "text-[#ff2a2a]" : "text-[#f5f5f0]"
                    }`}
                >
                    {value}/10
                </span>
            </div>
            <div className="h-1.5 w-full bg-[#0a0a0a] border border-[#262626]">
                <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
};

export default RiskMeter;
